import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons/faCircleExclamation'
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt'
import { Button, type ButtonProps, Flex, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreBookingDocument } from '@flecto/types/src/core/CoreBookingDocument'
import { ContextualCard } from '@flecto/ui'
import { Icon } from '@flecto/ui'
import useMediaQuery from '@flecto/ui/lib/utils/useMediaQuery'

import classes from './styles.module.css'

type DeleteButtonProps = ButtonProps & {
  document: Partial<Omit<CoreBookingDocument, 'type'>>
  onDelete?: () => void
}

export const DeleteButton = ({ document, onDelete }: DeleteButtonProps) => {
  const { t } = useTranslation('saas', { keyPrefix: 'booking' })
  const { isDesktop } = useMediaQuery()
  return (
    <ContextualCard
      popoverProps={{
        zIndex: 11000,
        width: 'auto',
      }}
    >
      <ContextualCard.Target>
        <Button
          variant='default'
          size='sm'
          color='gray'
          className={classes.deleteButton}
          fullWidth={isDesktop ? false : true}
          data-testid={'upload-btn-delete-uploaded'}
        >
          <Icon icon={faTrashAlt} />
        </Button>
      </ContextualCard.Target>
      <ContextualCard.Dropdown maw={300}>
        <Flex direction={'column'} gap={'sm'} p={'sm'}>
          <Icon
            icon={faCircleExclamation}
            color='red'
            size='md'
            withCircleBackground
          />
          <Text fw='500' my='sm' className={classes.deleteTitle}>
            {t('booking_documents.delete_modal_title', {
              documentName: document?.filename,
            })}
          </Text>
          <Text c='gray.6' size='sm' fw={400} mb='lg'>
            {t('booking_documents.delete_modal_description')}
          </Text>
        </Flex>
      </ContextualCard.Dropdown>
      <ContextualCard.Confirm onClick={onDelete} color='red' size='md'>
        {t('booking_documents.delete')}
      </ContextualCard.Confirm>
      <ContextualCard.Close size='md' />
    </ContextualCard>
  )
}
